const IconHamburgerMenu = (): JSX.Element => {
  return (
    <>
      <path
        fill="currentColor"
        d="M4.7,8.9c0-0.6,0.5-1.1,1.1-1.1H26c0.6,0,1.1,0.5,1.1,1.1S26.6,10,26,10H5.8C5.2,10,4.7,9.5,4.7,8.9z M4.7,15.7  c0-0.6,0.5-1.1,1.1-1.1H26c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1H5.8C5.2,16.8,4.7,16.3,4.7,15.7z M4.7,22.4  c0-0.6,0.5-1.1,1.1-1.1H26c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1H5.8C5.2,23.5,4.7,23,4.7,22.4z"
      />
    </>
  );
};

export default IconHamburgerMenu;
